// ============================================================
// firebase.config.js — Firebase Configuration & Initialization
// ============================================================
// Replace the values below with your actual Firebase project config
// found at: Firebase Console → Project Settings → General → Your apps

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC5InJQ90iu0y3X6h5uF0ouw0HcLvNszV4",
  authDomain: "chaitimecrunch.firebaseapp.com",
  projectId: "chaitimecrunch",
  storageBucket: "chaitimecrunch.firebasestorage.app",
  messagingSenderId: "252148721824",
  appId: "1:252148721824:web:9025bed2434eca55fc01c5",
  measurementId: "G-C3C1HVVG2T",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// ============================================================
// EMULATOR SUPPORT (for local development)
// ============================================================
// Uncomment the lines below when running Firebase emulators locally
// Run: firebase emulators:start

// if (window.location.hostname === "localhost") {
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, "localhost", 8080);
//   connectStorageEmulator(storage, "localhost", 9199);
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }

export default app;